const BASE_URL = "http://localhost:8000/api/method/";
const FILE_UPLOAD_URL = "http://localhost:8000/"

export {
    BASE_URL,
    FILE_UPLOAD_URL
}